module.exports = __webpack_public_path__ + "img/Anhui-speed.cea2ec11.png";